<template>
<div id="container">
    <div class="container_wrap">
        <keep-alive>
    		<search-asc-snb></search-asc-snb>
        </keep-alive>
        <router-view></router-view>
    </div>
</div>
</template>
<script>
import axios       from 'axios';
import SDLUtil     from '@/utils/SDLUtil';
import SearchAscSnb   from './SearchAscSnb';

export default {
    name: 'Search',
    components: {
    	'search-asc-snb' : SearchAscSnb
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/intgSearch/SearchAsc.vue